import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import I18n from '../../resources/i18n/I18n'
import Logo from '../logo/Logo'
import Title from '../typo/Title'
import './help.scss'

const Help = () => {
  const user = useSelector((state) => state.userReducer.user)
  return (
    <div className="help">
      <Logo />
      <div className="container">
        <div className="row">
          <Title text={I18n.t('HelpTitle')} />
        </div>
        <div className="row">
          <ul>
            <li>
              <a href={`${process.env.PUBLIC_URL}/USH-ORFI-manuel-utilisation.pdf`}>{I18n.t('HelpDoc')}</a>
            </li>
            <li>
              <Link to="/rgpd">{I18n.t('HelpRGPD')}</Link>
            </li>
          </ul>
        </div>
        <p>
          {user.roles && user.roles.indexOf('ORFI-GARDIEN') > -1 ? (
            I18n.t('HelpKeeper')
          ) : (
            <span>
              {I18n.t('HelpDirector')}
              <a href="mailto:orfi@union-habitat.org?subject=Support%20application%20ORFI">orfi@union-habitat.org</a>
            </span>
          )}
        </p>
      </div>
    </div>
  )
}

export default Help
